import Vue from "vue";
import { Button, Form, FormItem, Input, Divider, Dialog, Card, Message, MessageBox, Select, Option, Cascader, Loading  } from "element-ui";

Vue.use(Button).use(Form).use(FormItem).use(Input).use(Divider).use(Dialog).use(Card).use(Select).use(Option).use(Cascader).use(Loading);
Vue.prototype.$message = Message;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;

// 改写element消息弹框，让多个相同弹框时只弹一个
let messageInstance = null;
const resetMessage = (option) => {
  if (messageInstance) {
    messageInstance.close();
  }
  messageInstance = Message(option);
};

['error', 'success', 'info', 'warning'].forEach(type => {
  resetMessage[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options
      };
    }
    options.type = type;
    return resetMessage(options);
  };
});

export const Messages = resetMessage;